
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser.ts'
export { Prisma }
export * as $Enums from './enums.ts'
export * from './enums.ts';
/**
 * Model Address
 * 
 */
export type Address = Prisma.AddressModel
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model Account
 * 
 */
export type Account = Prisma.AccountModel
/**
 * Model Session
 * 
 */
export type Session = Prisma.SessionModel
/**
 * Model AuditLog
 * 
 */
export type AuditLog = Prisma.AuditLogModel
/**
 * Model OneTimePurchase
 * 
 */
export type OneTimePurchase = Prisma.OneTimePurchaseModel
/**
 * Model AttributionBridge
 * 
 */
export type AttributionBridge = Prisma.AttributionBridgeModel
/**
 * Model VerificationToken
 * 
 */
export type VerificationToken = Prisma.VerificationTokenModel
/**
 * Model ChatMessage
 * 
 */
export type ChatMessage = Prisma.ChatMessageModel
/**
 * Model Patient
 * 
 */
export type Patient = Prisma.PatientModel
/**
 * Model Therapist
 * 
 */
export type Therapist = Prisma.TherapistModel
/**
 * Model MinorGuardianConsent
 * 
 */
export type MinorGuardianConsent = Prisma.MinorGuardianConsentModel
/**
 * Model MinorGuardianConsentInvite
 * 
 */
export type MinorGuardianConsentInvite = Prisma.MinorGuardianConsentInviteModel
/**
 * Model Company
 * 
 */
export type Company = Prisma.CompanyModel
/**
 * Model TherapistDocument
 * 
 */
export type TherapistDocument = Prisma.TherapistDocumentModel
/**
 * Model TherapyRelationship
 * 
 */
export type TherapyRelationship = Prisma.TherapyRelationshipModel
/**
 * Model AdditionalService
 * 
 */
export type AdditionalService = Prisma.AdditionalServiceModel
/**
 * Model TherapistReport
 * 
 */
export type TherapistReport = Prisma.TherapistReportModel
/**
 * Model TherapistReportCheckout
 * 
 */
export type TherapistReportCheckout = Prisma.TherapistReportCheckoutModel
/**
 * Model UserReview
 * 
 */
export type UserReview = Prisma.UserReviewModel
/**
 * Model SessionReview
 * 
 */
export type SessionReview = Prisma.SessionReviewModel
/**
 * Model TherapySession
 * 
 */
export type TherapySession = Prisma.TherapySessionModel
/**
 * Model GoogleCalendarAccess
 * 
 */
export type GoogleCalendarAccess = Prisma.GoogleCalendarAccessModel
/**
 * Model WorkingHours
 * 
 */
export type WorkingHours = Prisma.WorkingHoursModel
/**
 * Model Earning
 * 
 */
export type Earning = Prisma.EarningModel
/**
 * Model Payout
 * 
 */
export type Payout = Prisma.PayoutModel
/**
 * Model Complaint
 * 
 */
export type Complaint = Prisma.ComplaintModel
/**
 * Model QuizSubmission
 * 
 */
export type QuizSubmission = Prisma.QuizSubmissionModel
/**
 * Model TherapistBreak
 * 
 */
export type TherapistBreak = Prisma.TherapistBreakModel
/**
 * Model AIChatMessage
 * 
 */
export type AIChatMessage = Prisma.AIChatMessageModel
/**
 * Model AssistantConversation
 * 
 */
export type AssistantConversation = Prisma.AssistantConversationModel
/**
 * Model AiSubscription
 * 
 */
export type AiSubscription = Prisma.AiSubscriptionModel
/**
 * Model AiConversation
 * 
 */
export type AiConversation = Prisma.AiConversationModel
/**
 * Model AiAssessment
 * 
 */
export type AiAssessment = Prisma.AiAssessmentModel
/**
 * Model Invoice
 * 
 */
export type Invoice = Prisma.InvoiceModel
/**
 * Model Referrer
 * 
 */
export type Referrer = Prisma.ReferrerModel
/**
 * Model ReferralVisit
 * 
 */
export type ReferralVisit = Prisma.ReferralVisitModel
/**
 * Model ReferralConversion
 * 
 */
export type ReferralConversion = Prisma.ReferralConversionModel
/**
 * Model DiscountCampaign
 * 
 */
export type DiscountCampaign = Prisma.DiscountCampaignModel
/**
 * Model DiscountUsage
 * 
 */
export type DiscountUsage = Prisma.DiscountUsageModel
/**
 * Model TestMagicLink
 * 
 */
export type TestMagicLink = Prisma.TestMagicLinkModel
/**
 * Model TestDiagnosticEvent
 * 
 */
export type TestDiagnosticEvent = Prisma.TestDiagnosticEventModel
/**
 * Model GiftCard
 * 
 */
export type GiftCard = Prisma.GiftCardModel
/**
 * Model CreditTransaction
 * 
 */
export type CreditTransaction = Prisma.CreditTransactionModel
/**
 * Model Organisation
 * 
 */
export type Organisation = Prisma.OrganisationModel
/**
 * Model OrganisationMembership
 * 
 */
export type OrganisationMembership = Prisma.OrganisationMembershipModel
/**
 * Model OrganisationPurchase
 * 
 */
export type OrganisationPurchase = Prisma.OrganisationPurchaseModel
/**
 * Model OrganisationInvite
 * 
 */
export type OrganisationInvite = Prisma.OrganisationInviteModel
/**
 * Model BlogReview
 * 
 */
export type BlogReview = Prisma.BlogReviewModel
/**
 * Model AcquisitionSelfReport
 * 
 */
export type AcquisitionSelfReport = Prisma.AcquisitionSelfReportModel
/**
 * Model MetaLead
 * 
 */
export type MetaLead = Prisma.MetaLeadModel
/**
 * Model ConcernCatalog
 * 
 */
export type ConcernCatalog = Prisma.ConcernCatalogModel
/**
 * Model TherapistConcern
 * 
 */
export type TherapistConcern = Prisma.TherapistConcernModel
/**
 * Model TherapistApproach
 * 
 */
export type TherapistApproach = Prisma.TherapistApproachModel
/**
 * Model ApproachCatalog
 * 
 */
export type ApproachCatalog = Prisma.ApproachCatalogModel
/**
 * Model TherapistQualification
 * 
 */
export type TherapistQualification = Prisma.TherapistQualificationModel
/**
 * Model TherapistPracticeSnapshot
 * 
 */
export type TherapistPracticeSnapshot = Prisma.TherapistPracticeSnapshotModel
